import React from 'react';
import PropTypes from 'prop-types';

import RacingThemeSearchActiveFilters from './RacingThemeSearchActiveFilters';
import RacingThemeSearchResultsToolbar from './RacingThemeSearchResultsToolbar';
import RacingThemeSearchResultsGrid from './RacingThemeSearchResultsGrid';
import RacingThemeSearchPagination from './RacingThemeSearchPagination';
import styles from './RacingThemeSearchResultsPanel.module.css';

const listingShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

/**
 * Search results main panel.
 */
const RacingThemeSearchResultsPanel = props => {
  const {
    listings,
    filters,
    count,
    query,
    sortOptions,
    activeSort,
    onSortChange,
    onRemoveFilter,
    pagination,
    pageName,
    pagePathParams,
    pageSearchParams,
    children,
    onToggleFavorite = null,
  } = props;

  return (
    <section className={styles.resultsPanel}>
      <RacingThemeSearchActiveFilters filters={filters} onRemove={onRemoveFilter} />
      <RacingThemeSearchResultsToolbar
        count={count}
        query={query}
        sortOptions={sortOptions}
        activeSort={activeSort}
        onSortChange={onSortChange}
      />
      {children}
      {listings?.length > 0 ? (
        <RacingThemeSearchResultsGrid listings={listings} onToggleFavorite={onToggleFavorite} />
      ) : null}
      <RacingThemeSearchPagination
        pagination={pagination}
        pageName={pageName}
        pagePathParams={pagePathParams}
        pageSearchParams={pageSearchParams}
      />
    </section>
  );
};

RacingThemeSearchResultsPanel.propTypes = {
  listings: PropTypes.arrayOf(listingShape),
  filters: PropTypes.array,
  count: PropTypes.number,
  query: PropTypes.string,
  sortOptions: PropTypes.array,
  activeSort: PropTypes.string,
  onSortChange: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  pagination: PropTypes.object,
  pageName: PropTypes.string,
  pagePathParams: PropTypes.object,
  pageSearchParams: PropTypes.object,
  children: PropTypes.node,
  onToggleFavorite: PropTypes.func,
};

export default RacingThemeSearchResultsPanel;
